document.addEventListener( 'DOMContentLoaded', function () {
	const toggleTabs = document.querySelectorAll( '.toggle-tab' );
	const toggleTabWrapper = document.querySelector( '.toggle-tab-wrapper' );
	const tabContent = document.querySelectorAll( '.tab-content' );
	// Exit early if no .toggle-tab elements are found
	if ( toggleTabs.length === 0 || !toggleTabWrapper || tabContent.length === 0 ) return;
	toggleTabWrapper.addEventListener( 'click', function( event ) {
		if ( event.target.classList.contains( 'toggle-tab' ) ) {
			toggleTabs.forEach( ( tab ) => {
				tab.classList.toggle( 'active' );
			} );
		}
		tabContent.forEach( ( content ) => {
			content.classList.toggle( 'hide' );
		} );
	} );
} );